<template>
  <SelectSingleInput
    :vid="vid"
    v-model="model"
    :items="items"
    item-text="userText"
    item-value="userCd"
    :label="labelComputed"
    :exceptCdList="exceptCdList"
    :exceptComparator="exceptComparator"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'UserInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    companyCd: {
      type: String,
      default: '',
      required: false,
    },
    companyCat: {
      type: String,
      default: '',
      required: false,
    },
    roleCdList: {
      type: Array,
      required: false,
      default: () => [],
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0058')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    exceptCdList: {
      type: Array,
      required: false,
      default: () => [],
    },
    vid: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  watch: {
    async companyCd() {
      if (this.companyCd) {
        await this.setUser()
      }
    },
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label
      },
    },
  },

  methods: {
    exceptComparator(item, except) {
      return item.userCd == except.userCd && item.userCd != this.model
    },
    async setUser() {
      this.loading = true
      try {
        let params = {
          validOnly: this.validOnly,
        }

        if (this.companyCd) {
          params.companyCd = this.companyCd
        }

        if (this.companyCat) {
          params.companyCat = this.companyCat
        }

        if (this.roleCdList) {
          params.roleCds = this.roleCdList
        }

        const elements = await API.get('/master/company/users', params)
        this.items = []
        elements.forEach((element) => {
          element['userText'] = element['userCd'] + ' : ' + element['userName']
          this.items.push(element)
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0058') })))
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    await this.setUser()
  },
}
</script>
